var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1AudioAndVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#H1_Audio_and_video_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.77 30.06H53a4 4 0 00-4 4V41a4 4 0 004 4h4l19 15V14L57.77 30.06zm14.31 20.81L61 42.94V32.57l11.08-9.43v27.73zM40 20H4a4 4 0 00-4 4v24a4 4 0 004 4h16v5h-9v4h22v-4h-9v-5h16a4 4 0 004-4V24a4 4 0 00-4-4zm0 28H4V24h36v24z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "H1_Audio_and_video_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h76v76H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/H1_Audio_and_video.4038efc1.svg";
export { SvgH1AudioAndVideo as ReactComponent };